import { render, staticRenderFns } from "./EmailResetPage.vue?vue&type=template&id=25a7e2b8&scoped=true"
import script from "./EmailResetPage.vue?vue&type=script&lang=js"
export * from "./EmailResetPage.vue?vue&type=script&lang=js"
import style0 from "./EmailResetPage.vue?vue&type=style&index=0&id=25a7e2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a7e2b8",
  null
  
)

export default component.exports